import { minLength, maxLength, stringPattern, stringPatternError, tagMinLength, tagMaxLength } from '../../utils/form-validations';

export const thmeShema: any = {
  type: 'object',
  properties: {
    // primary_color: {
    //   type: 'string',
    //   minLength,
    //   maxLength,
    // },
    // secondary_color: {
    //   type: 'string',
    //   minLength,
    //   maxLength,
    // },
    "things_machines": {
      type: 'object',
      properties: {
        "entity_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
        "page_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
      },
    },
    "things_gateways": {
      type: 'object',
      properties: {
        "entity_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
        "page_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
      },
    },
    "things_parts": {
      type: 'object',
      properties: {
        "entity_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
        "page_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
      },
    },
    "site_factory": {
      type: 'object',
      properties: {
        "entity_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
        "page_name": {
          "type": 'string',
          "minLength": minLength,
          "maxLength": maxLength,
        },
      },

      required: ['entity_name', 'page_name'],
    },
  },
  required: ['primary_color', 'site_factory'],
  additionalProperties: true,
};


export const defaultPageSetting: any = {
  config: {
    background_color: '#F8FAFB',
    primary_color: "#5C85FF",
    secondary_color: "#FFFFFF",
    text_color: "#434D67",
    font_changes: {
      font_name: "Default",
      cdn_url: "Default"
    },
    things_machines: {
      entity_name: "Machine",
      page_name: "Machinery Management",
    },
    things_parts: {
      entity_name: "Part",
      page_name: "Part Management",
    },
    things_gateways: {
      entity_name: "Gateway",
      page_name: "Gateway Management"
    },
    site_factory: {
      entity_name: "Factory",
      page_name: "Factory Management"
    }
  },
  status: "noinput"
};

export const defaultColors: any = {
  background_color: '#F8FAFB',
  primary_color: "#5C85FF",
  secondary_color: "#FFFFFF",
  text_color: "#434D67",
}

export const defaultColorsLabels: any = {
  background_color: 'Background Color',
  primary_color: "Button & Highlight Color",
  secondary_color: "Left Navigation Color",
  text_color: "Typography Color",
}

export const defaultColorsTooltip: any = {
  background_color: 'You can modify the background color of the main layout and its elements, such as cards, tables, and pop-ups.',
  primary_color: "You can modify the color of all buttons and hyperlinks.",
  secondary_color: "You can modify the background color of main navigation.",
  text_color: "You can modify the font color of the entire application.",
}


export const defaultTextFields: any = {
  things_machines: "Machinery Management",
  things_parts: "Parts Management",
  things_gateways: "Gateway Management",
  site_factory: "Factory Management"
}
